import { Toggle } from '@fluentui/react';
import { Search } from '@h2oai/ui-kit';
import { useState } from 'react';

import { useTimeFilters } from './common/hooks';
import { formatDateLocal } from './common/utils';
import AIEMTable from './components/AIEM/AIEMTable/AIEMTable';
import TimeFilters from './components/TimeFilters/TimeFilters';
import PageWrapper from './PageWrapper';

export default function AIEM() {
  const { startDate, endDate, selectedTimeFrame, handleTimeFilterChange } = useTimeFilters();
  const [searchQuery, setSearchQuery] = useState('');
  const [showComputeResource, setShowComputeResource] = useState<boolean>(true);

  const handleToggleChange = (_event: React.MouseEvent<HTMLElement>, checked?: boolean) => {
    setShowComputeResource(checked || false);
  };

  return (
    <PageWrapper>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '1rem',
        }}
      >
        <Toggle
          inlineLabel={true}
          label={'Show Compute Resource'}
          checked={showComputeResource}
          onChange={handleToggleChange}
        />
        <TimeFilters
          startDate={startDate}
          endDate={endDate}
          selectedTimeFrame={selectedTimeFrame}
          onChange={handleTimeFilterChange}
        />
      </div>
      <div style={{ marginBottom: '1rem' }}>
        <Search
          emptyMessage="No results found"
          placeholder="Search by Engine/User..."
          onSearchTextChange={(text: string) => setSearchQuery(text)}
          style={{ width: '250px' }}
        />
      </div>

      <div style={{ marginTop: '10px' }}>
        <AIEMTable
          startDate={formatDateLocal(startDate)}
          endDate={formatDateLocal(endDate)}
          showComputeResource={showComputeResource}
          searchQuery={searchQuery}
        />
      </div>
    </PageWrapper>
  );
}
